module.exports = __webpack_public_path__ + "static/about_background_2-8fd905feb142af98752d8a57a7e80bc9.jpg";